<app-si-dialog #dialog header="CSV Settings" [isLoading]="isLoading$ | async" [saveButtonDisabled]="isLoading$ | async" (save)="saveSettings(dialog)">
    <ng-template appDialogBody>
        <form [formGroup]="csvsettings" class="py-6">
            <div class="flex flex-wrap -mx-2 gap-0 items-center">
                <div class="w-full sm:flex-none sm:w-1/12 px-2">
                </div>
                <div class="w-full sm:flex-none sm:w-7/12 py-2 px-2">
                    Export State as Abbreviation
                </div>

                <div class="w-full sm:flex-none sm:w-1/6 px-2">
                    <mat-slide-toggle
                        formControlName="exportStateAsAbbreviation"
                    ></mat-slide-toggle>
                </div>
            </div>

            <div class="flex flex-wrap -mx-2 gap-0 items-center">
                <div class="w-full sm:flex-none sm:w-1/12 px-2">
                </div>
                <div class="w-full sm:flex-none sm:w-7/12 py-2 px-2">
                    Export Country as Abbreviation
                </div>

                <div class="w-full sm:flex-none sm:w-1/6 px-2">
                    <mat-slide-toggle
                        formControlName="exportCountryAsAbbreviation"
                    ></mat-slide-toggle>
                </div>
            </div>

            <div class="flex flex-wrap -mx-2 gap-0">
                <div class="w-full sm:flex-none sm:w-1/12 px-2">
                </div>
                <div class="w-full sm:flex-none sm:w-7/12 py-2 px-2">
                    Export Employee count
                </div>

                <div class="w-full sm:flex-none sm:w-1/6 px-2">
                    <mat-slide-toggle
                        formControlName="exportEmployeeCount"
                    ></mat-slide-toggle>
                </div>
            </div>

            <div class="flex flex-wrap -mx-2 gap-0 items-center">
                <div class="w-full sm:flex-none sm:w-1/12 px-2">
                </div>
                <div class="w-full sm:flex-none sm:w-7/12 py-2 px-2">
                    Export Revenue
                </div>

                <div class="w-full sm:flex-none sm:w-1/6 px-2">
                    <mat-slide-toggle
                        formControlName="exportRevenue"
                    ></mat-slide-toggle>
                </div>
            </div>
        </form>
    </ng-template>
</app-si-dialog>
